import { Feature } from './feature'
import {Hero} from './hero'
import { Pricing, PricingTopUp } from './pricing'
import { Payment } from "./payment";
import { userAtom } from '../../recoil/atoms'
import { useRecoilState } from 'recoil'

const Landing = () => {
    const [user, setUser] = useRecoilState(userAtom)

    return (
        <>
            <Hero />
            <Feature />
            {user.is_plus && <PricingTopUp />} 
            {!user.is_plus && <Pricing />} 
        </>
    )
}

export default Landing
  